// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","icon":"_2vcBP-JHxRNHIzwneV3tz2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/icons.css
// module id = 905
// module chunks = 0